import * as React from 'react';
import * as PropTypes from 'prop-types';
import Glider from 'react-glider';

const SlidePostContainer = ({ isSlide = false, children }) => {
  if (!isSlide) return <>{children}</>;

  return (
    <Glider
      hasDots
      hasArrows
      draggable
      slidesToShow={4}
      slidesToScroll={4}
      responsive={[
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ]}
    >
      {children}
    </Glider>
  );
};

SlidePostContainer.propTypes = {
  isSlide: PropTypes.bool,
  children: PropTypes.any,
};

export { SlidePostContainer };
